// extracted by mini-css-extract-plugin
export var wrapper = "styles-module__wrapper___xS6ot";
export var forgotPassword = "styles-module__forgotPassword___Opu4i";
export var sectionDivider = "styles-module__sectionDivider___WUTtx";